/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Works_Header_LabelInputs */

const en_works_header_label = /** @type {(inputs: Works_Header_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent Portfolio`)
};

const ar_works_header_label = /** @type {(inputs: Works_Header_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحدث الأعمال`)
};

const bn_works_header_label = /** @type {(inputs: Works_Header_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাম্প্রতিক কাজ`)
};

const de_works_header_label = /** @type {(inputs: Works_Header_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelles Portfolio`)
};

const es_works_header_label = /** @type {(inputs: Works_Header_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartera reciente`)
};

const fr_works_header_label = /** @type {(inputs: Works_Header_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portefeuille récent`)
};

const pt_works_header_label = /** @type {(inputs: Works_Header_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portfólio recente`)
};

const zh_works_header_label = /** @type {(inputs: Works_Header_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近的投资组合`)
};

const tr_works_header_label = /** @type {(inputs: Works_Header_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son Portföy`)
};

const ru_works_header_label = /** @type {(inputs: Works_Header_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недавнее портфолио`)
};

const pl_works_header_label = /** @type {(inputs: Works_Header_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najnowsze portfolio`)
};

/**
* | output |
* | --- |
* | "Recent Portfolio" |
*
* @param {Works_Header_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const works_header_label = /** @type {((inputs?: Works_Header_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Works_Header_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_works_header_label(inputs)
	if (locale === "bn") return bn_works_header_label(inputs)
	if (locale === "de") return de_works_header_label(inputs)
	if (locale === "es") return es_works_header_label(inputs)
	if (locale === "fr") return fr_works_header_label(inputs)
	if (locale === "pt") return pt_works_header_label(inputs)
	if (locale === "zh") return zh_works_header_label(inputs)
	if (locale === "tr") return tr_works_header_label(inputs)
	if (locale === "ru") return ru_works_header_label(inputs)
	if (locale === "pl") return pl_works_header_label(inputs)
	return en_works_header_label(inputs)
});